import { Box, CircularProgress } from "@mui/material";

const CircProgress = () => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "inherit",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        // position: "fixed",
      }}
    >
      <CircularProgress />
    </Box>
  );
};
export default CircProgress;
